// Types related to CBCT Molar report ("molarviz") pipelines method

// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file pipelines/report_cbct_molar.proto (package com.diagnocat.pipelines, syntax proto3)
/* eslint-disable */

import { proto3 } from "@bufbuild/protobuf";
import { CBCTSeriesGeometryData } from "../model/dto_common_geometry_pb.js";

/**
 * @generated from message com.diagnocat.pipelines.CBCT_Molar_Update
 */
export const CBCT_Molar_Update = proto3.makeMessageType(
  "com.diagnocat.pipelines.CBCT_Molar_Update",
  () => [
    { no: 1, name: "CropGeometryData", kind: "message", T: CBCTSeriesGeometryData, oneof: "Update" },
  ],
);

